module.exports = __webpack_public_path__ + "static/img/contact.50a19026.jpg";